import ResumeTypes from './types';
import { ServersResumeState, ServersResumeDispatchAction } from './state';
import { Reducer } from 'redux';

export const resumeReducer : Reducer<[ServersResumeState]|null, ServersResumeDispatchAction> = 
    ( state = null, action) => {
        switch(action.type) {
            case ResumeTypes.FETCH_START:
                return state
            case ResumeTypes.FETCH_SUCCESS:
                return action.payload
            default: 
                return state
        }
    }

export default resumeReducer;